// extracted by mini-css-extract-plugin
export default {"imageContainer":"styles_imageContainer__cNBfN","reviewButton":"styles_reviewButton__slsaL","cancelButton":"styles_cancelButton__nELQX"};